import { createTranslations } from '@npco/utils-translations'

export const downloadRemittanceTranslations = createTranslations({
  pdfName: 'Transfer_Remittance_{id}',
  errorMessage: 'Something went wrong. Please try again.',
})
